import React from "react";
import { connect } from "react-redux";
import {
  setQuantity,
  SetQuantityPayload,
} from "../state/actions/choiceActions";
import { RootState } from "../state/reducers";
import { ActionPayload, ID, Layout } from "../types";

interface PartQuantityProps {
  partId: ID;
  max: string;
  setQuantity: (id: ID, amount: number) => ActionPayload<SetQuantityPayload>;
  quantity?: number;
  layout: Layout;
  isSelected: boolean;
}

const PartQuantity: React.FC<PartQuantityProps> = ({
  partId,
  max,
  setQuantity,
  quantity,
  layout,
  isSelected,
}) => {
  const maxInt = parseInt(max, 10);
  const valueChange = (e: React.FormEvent<HTMLInputElement>) => {
    const current = parseInt(e.currentTarget.value, 10);
    if (current < 1) return setQuantity(partId, 1);
    if (current > maxInt) return setQuantity(partId, maxInt);
    return setQuantity(partId, current);
  };
  if (!max || max === "1" || !isSelected || layout === "rows") return null;
  return (
    <div className="part-quantity">
      <span className="part-quantity-label">amount: </span>
      <input
        type="number"
        min="1"
        max={maxInt}
        value={quantity ? quantity : 1}
        onChange={valueChange}
      />
    </div>
  );
};

interface connectProps {
  max: string;
  partId: ID;
  layout: Layout;
  isSelected: boolean;
}

export default connect(
  (state: RootState, props: connectProps) => {
    const { max, partId, layout, isSelected } = props;
    return {
      partId,
      max,
      quantity: state.choices.byId[partId]?.quantity,
      layout,
      isSelected,
    };
  },
  { setQuantity }
)(PartQuantity);
